export interface U2103LoadLogicalUnitActionHandlersParams<T = any> {
  doLoadLogicalUnitFn: () => Promise<any>;
  onSuccess?: (rows: T[]) => void;
  onError?: (errors: { error: any }) => void;
}

export interface U2103LoadLogicalUnitActionHandlersReturn {
  loadLogicalUnitActions: () => void;
}

export function useU2103LoadLogicalUnitActionHandlers<T extends { id: string } = any>({
  doLoadLogicalUnitFn,
  onSuccess,
  onError,
}: U2103LoadLogicalUnitActionHandlersParams<T>): U2103LoadLogicalUnitActionHandlersReturn {
  const loadLogicalUnitActions = async () => {
    try {
      const response = await doLoadLogicalUnitFn();
      const rows: T[] = response.data.results as unknown as T[];

      if (onSuccess) {
        onSuccess(rows);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { loadLogicalUnitActions };
}
